import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
// import { browserHistory } from 'react-router';

import ContactListRow from '../components/ContactListRow';
import InfiniteScroll from 'react-infinite-scroller';

import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import RolodexEmptyMessageSvgIcon from 'src/legacy/images/rolodexEmptyMessage.svg';
import { localizedStrings } from 'src/localization';
import styles from './ContactListView.module.scss';

class ContactListView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      contactFormView: false,
      isDistributionListView: false,
      currentPage: this.props.currentPage,
    }

    this.loadMoreContactLists = this.loadMoreContactLists.bind(this);
    this._renderContactList = this._renderContactList.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedDistributionList = this.localizatedSettings.distribution_lists;
    this.localizedEmptyMessage = this.localizedDistributionList.sliders.add_contacts.empty_message;
  }

  componentDidMount() {
    this.handleUrlChange(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.location.query.query != nextProps.location.query.query)) {
      this.handleUrlChange(nextProps);
    }
    
    if (!nextProps.params.id && nextProps.contactLists && nextProps.contactLists.length > 0) {
      this.props.navigate(`/settings/contact_list/${nextProps.contactLists[0].id}`);
    }

    // var query = nextProps.location.query["query"] || '';
    // var previousQuery = this.props.location.query["query"] || '';
    // if (query != previousQuery && nextProps.contactLists && nextProps.contactLists.length > 0) {
    //   this.props.navigate(`/settings/contact_list/${nextProps.contactLists[0].id}`);
    // }
  }

  handleUrlChange(props) {
    console.log('change',props);
    
    var query = props.location.query["query"] || ''
    this.props.fetchContactLists(0, query);
  }

  loadMoreContactLists(page) {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    var query = this.props.location.query['query'] || '';

    this.props.fetchContactLists(nextPage, query);
  }

  _scrollIntoView(id) {
    let row = `${id}-contact_list`;
    if (this.refs[row]) {
      var selectedContact = ReactDOM.findDOMNode(this.refs[row]);

      if (selectedContact) {
        this.scrollContainer.scrollTop = selectedContact.offsetTop - 191;
      }
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.list}>
          <div className={styles.inner} ref={(element) => {
            this.scrollContainer = element;
          }}>

            {this._renderContactList()}

            {this.props.loading &&
              <div className={styles.loading}>{this.localizedCommons.loading.lists} ...</div>
            }
          </div>
        </div>  
      </div>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedEmptyMessage.title}
        message={this.localizedEmptyMessage.sub_text}
        image={RolodexEmptyMessageSvgIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderContactList() {
    if (!this.props.contactLists) {
      return null;
    }

    if (!this.props.loading && this.props.contactLists.length == 0 && this.props.query != '') {
      return this._renderEmptyMessage();
    }

    let contacts = Array();

    this.props.contactLists && this.props.contactLists.forEach((contactList, index) => {
      var url = `/settings/contact_list/${contactList.id}`
      
      contacts.push(
        <ContactListRow 
          key={contactList.id} 
          ref={`${contactList.id}-contact_list`} 
          contactList={contactList} 
          url={url}      
          defaultActive={index===0}
          showBorders={true}
        />
      );
    });

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={this.loadMoreContactLists}
        useWindow={false}
        threshold={200}
      >
        {contacts}
      </InfiniteScroll>
    );
  }
}
export default ContactListView;